<template>
  <TableDropdown
    :title="folderTeam.name"
    size-title="l"
    row-class="-gray-"
    header-class="-team-analityc-table-"
    :revenue="revenue"
    :profit="profit"
    @isOpen="watchStateDropdown"
  >
    <template v-if="isTeamLoading">
      <EmptyRow
        v-for="user in +folderTeam.count"
        :key="user"
        class="-pointer-"
        :nav-titles="navTitles"
        height="43px"
      />
    </template>
    <template v-else>
      <TeamRow
        v-for="user in team.users"
        :key="user.id"
        :leader="team.leader"
        :user="user"
        :nav-titles="navTitles"
        height="43px"
        @click.native="openUserTraction(user.id)"
      />
    </template>
  </TableDropdown>
</template>

<script>
import { mapState } from 'vuex';
import TeamRow from './TeamRow';
import EmptyRow from './EmptyRow';
import TableDropdown from './TableDropdown';
import numberFormat from '@/filters/numberFormat.filter';

export default {
  components: {
    TeamRow,
    EmptyRow,
    TableDropdown
  },
  props: {
    navTitles: {},
    folderTeam: {}
  },
  data: () => ({
    isTeamLoading: false
  }),
  computed: {
    ...mapState('ratingTeams', {
      teamList: s => s.data.teamList
    }),
    team() {
      const team =
        this.teamList.find(item => item.id === this.folderTeam.id) || {};
      return team;
    },
    revenue() {
      if (this.folderTeam.revenue !== null) {
        return `${numberFormat(this.folderTeam.revenue)} ₽`;
      }
      return 'Нет данных';
    },
    profit() {
      if (this.folderTeam.profit !== null) {
        return `${numberFormat(this.folderTeam.profit)} ₽`;
      }
      return 'Нет данных';
    }
  },
  methods: {
    async getTeam() {
      if (
        this.teamList.findIndex(item => item.id === this.folderTeam.id) === -1
      ) {
        this.isTeamLoading = true;
        await this.$store.dispatch('ratingTeams/getTeam', this.folderTeam.id);
        this.isTeamLoading = false;
      }
    },
    watchStateDropdown(isOpen) {
      if (isOpen) {
        this.getTeam();
      }
    },
    openUserTraction(userId) {
      this.$router.push(`/rating/unified/user/${userId}`);
    }
  }
};
</script>
